import { RelatorioTaxaFixaEProducaoService } from './../../../../services/relatorios/taxa-fixa-e-producao/relatorio-taxa-fixa-e-producao.service';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ETipoRelatorio } from 'src/app/enums/relatorios/ETipoRelatorio.enum';
import { IRelatorioTaxaFixaEProducaoResponseData } from 'src/app/interfaces/relatorio/TaxaFixaEProducao/IRelatorioTaxaFixaEProducaoResponseData';

@Component({
  selector: 'app-relatorio-taxa-fixa-e-producao',
  templateUrl: './relatorio-taxa-fixa-e-producao.component.html',
  styleUrls: ['./relatorio-taxa-fixa-e-producao.component.scss']
})
export class RelatorioTaxaFixaEProducaoComponent {
  private subscriptions$ = new Subscription();
  relatorio: IRelatorioTaxaFixaEProducaoResponseData;
  codigoContrato: string;
  mesAno: string;
  constructor(
    private relatorioTaxaFixaEProducaoService: RelatorioTaxaFixaEProducaoService,
    private route: ActivatedRoute
  ) {}

  getDadosRelatorioInformatica() {
    this.subscriptions$.add(
      this.relatorioTaxaFixaEProducaoService
        .postRelatorioTaxaFixaEProducao({
          codigoContrato: this.codigoContrato,
          mesReferencia: this.mesAno,
          tipoExportacao: ETipoRelatorio.PDF
        })
        .subscribe({
          next: ({ data }) => {
            this.relatorio = data;
          }
        })
    );
  }
  ngOnInit() {
    this.route.params.subscribe(
      (params) => (
        (this.codigoContrato = params['codContrato']),
        (this.mesAno = params['mesAno'])
      )
    );
    this.getDadosRelatorioInformatica();
  }
}
